import React from 'react'
import Page from "../Page";
import EmptyBanner from "../../components/EmptyBanner";
import CardList from "../../components/CardList";
import LoadingBanner from "../../components/LoadingBanner";
import ErrorBanner from "../../components/ErrorBanner";
import Opportunity from "../../models/Opportunity";
import OppPanel from "./OppPanel";
import StatusTabs from "../../components/nav/StatusTabs";
import TalentPortal from "../talent-portal/TalentPortal";
import Modal from "../../components/Modal";
import OppTeamStatusModalStep from "./OppTeamStatusModalStep";
import JobPositionPanel from "../talent-job-board/components/JobPositionPanel";
import { generatePath, Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../components/nav/Footer";
import PageNotAllowed from "../../components/errors/PageNotAllowed";
import {useAuth} from "../../providers/AuthProvider";

export default class OppList extends Page {
    static path = '/projects/:status';

    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
        this.matchDetailsModal = React.createRef();


        this.state = {
            isLoading: true,
            tabs: TB.reduce(['All', ...Opportunity.statusOptions()], (result, key) => {
                result[key] = [];
                return result
            }, {})
        }
    }

    getStatusFromQuery() {
        return TB.find(['All', ...Opportunity.statusOptions()],
            status => TB.slugify(status) === (this.props.status || 'all')) || 'All'
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchProjectsForTalent()
    }

    async fetchProjectsForTalent() {
        await this.promisedState({
            groupedProjects: undefined,
            isLoading: true,
            error: null,
        });

        // show loading feedback
        let opportunities = await Opportunity.fetchAllForTalent();

        if (!opportunities) {
            return this.handleErrorResponse(
                Opportunity.FetchAllRequest, 'error_index_client_projects'
            );
        }

        let normalized = TB.map(opportunities, opportunity => {
            opportunity.display_status = opportunity.displayStatus();
            return opportunity;
        });

        let statusOptions = Opportunity.statusOptions();

        normalized = TB.orderBy(normalized, [opp => statusOptions.indexOf(opp.display_status), 'created_at'], ['asc', 'desc']);

        let groupedProjects = TB.groupBy(normalized, 'display_status');

        let tabs = {
            'All': normalized
        };

        for (let status of Opportunity.statusOptions()) {
            tabs[status] = groupedProjects[status] || [];
        }

        await this.promisedState({
            groupedProjects,
            error: null,
            isLoading: false,
            tabs
        });
    }

    async toggleJobModal(modal, selectedJob) {
        await this.promisedState({ selectedJob })
        return selectedJob ? modal.current?.showModal() : modal.current?.hideModal(true);
    }

    statusFromSlug(statusSlug) {
        return TB.titleCase(statusSlug.replace('-', ' '))
    }

    projectsWithStatus(statusSlug) {
        if (!this.state.groupedProjects) {
            return;
        }

        let projectStatus = this.statusFromSlug(statusSlug);


        return this.state.tabs[projectStatus] || [];
    }

    selectStatus(status) {
        return this.props.navigate({
            pathname: TalentPortal.projectsListPath(TB.slugify(status))
        }, { replace: true })
    }

    renderProjects() {
        if (!this.state.groupedProjects) {
            return <div />
        }

        let displayStatus = this.getStatusFromQuery();

        let groupedProjects = this.state.groupedProjects;
        let emptyMessage = "No Projects Found";

        if (displayStatus !== 'All') {
            groupedProjects = { [displayStatus]: [...(this.state.groupedProjects[displayStatus] || [])] }
            emptyMessage = `No ${displayStatus} Projects Found`;
        }


        return (
            <div className="project-list opportunity-list full-card-list">

                {TB.flatten(TB.values(groupedProjects)).length === 0 ? (
                    <EmptyBanner
                        style={{ paddingTop: '200px' }}
                        message={emptyMessage} />
                ) : TB.map(groupedProjects, (groupProjects, group) => {

                    return (
                        // <div className="opportunity-group-container" key={"group-" + group}>
                        <div className="project-group-container opportunity-group-container [&_.card-list-item]:self-stretch" key={"group-" + group}>

                            <CardList fillContainer maxItemsPerRow={3} items={groupProjects.map(opportunity => {
                                if (opportunity.isInterested()) {
                                    if (!opportunity.project_position) {
                                        return null;
                                    }
                                    let job = opportunity.relatedJob()
                                    return (
                                        <JobPositionPanel
                                            job={job}
                                            disabled={false}
                                            onRequest={(callback) => {
                                                return callback()
                                            }}
                                            onUpdateJob={() => this.fetchProjectsForTalent()}
                                            opportunity={opportunity}
                                        />
                                    )
                                }

                                return (
                                    <OppPanel
                                        key={`opportunity${opportunity.id}`}
                                        onShowTeam={async () => {
                                            await this.promisedState({ selectedOpportunity: opportunity });
                                            await TB.wait(100);
                                            this.modalRef.current.showModal();
                                        }}
                                        opportunity={opportunity}
                                        auth={this.context.auth}
                                    />
                                )
                            })}>

                                <h3 className="opportunity-group-title"
                                    style={{
                                        color: Opportunity.colorForStatus(group),
                                        borderColor: Opportunity.colorForStatus(group)
                                    }}>
                                    {group}
                                </h3>
                            </CardList>
                        </div>

                    )
                })}

                <Modal ref={this.modalRef}
                    modalClass={"team-status-modal"}
                    onCloseAction={() => {
                        this.setState({ selectedOpportunity: null })
                    }}>
                    {this.state.selectedOpportunity && (
                        <OppTeamStatusModalStep
                            opportunity={this.state.selectedOpportunity}
                            onClose={async (callback, shouldRefresh = false) => {

                                let selectedOpp = this.state.selectedOpportunity;

                                // console.log('updatedStatus', selectedOpp.displayStatus())
                                await this.modalRef.current.hideModal();

                                if (shouldRefresh) {
                                    this.setState({ isLoading: true })
                                    await TB.wait(250);

                                    await this.fetchProjectsForTalent();

                                    let opps = TB.flatten(TB.values(this.state.groupedProjects));

                                    let updatedOpp = TB.find(opps, ['id', selectedOpp.id]);
                                    // console.log('opps', {opps, updatedOpp})

                                    // console.log('updatedStatus', updatedOpp?.displayStatus())
                                    if (updatedOpp?.displayStatus() !== this.getStatusFromQuery()) {
                                        await this.selectStatus(updatedOpp?.displayStatus())
                                    }
                                }
                                if (callback) {
                                    await TB.wait(250);
                                    await callback();
                                }
                            }}
                        />
                    )}
                </Modal>
            </div>
        );
    }

    render() {
        let {
            isDisabled, isLoading, error, tabs, selectedJob
        } = this.state;

        return (
            <div className="flex-grow justify-start flex flex-col items-stretch gap-[30px]">

                {tabs && (
                    <div className="py-6 bg-gray project-status-tabs">

                        <StatusTabs
                            tabs={tabs}
                            isDisabled={isLoading}
                            buttonStyles={{ width: 'unset' }}
                            activeTab={this.getStatusFromQuery()}
                            onChange={this.selectStatus.bind(this)} />

                    </div>
                )}

                {isLoading && <LoadingBanner message="projects.client_dashboard.loading" />}

                {TB.isObject(error) && (
                    <ErrorBanner {...error} onRetry={this.fetchProjectsForTalent.bind(this)} />
                )}

                {!isLoading && !TB.isObject(error) && this.renderProjects()}

                <Footer />
            </div>
        );
    }
}

const OpportunityList = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { status } = useParams();

    const {auth} = useAuth()
    if (!status) {
        return <Navigate to={generatePath('/talent/projects/:status', { status: 'all' })} />
    }

    if (auth.isTalent() && !auth.isProfileApproved()) {
        return <PageNotAllowed redirect="/talent/dashboard" message="Your profile must be approved before accessing this page."/>;
    }
    return (
        <OppList navigate={navigate} location={location} status={status} />
    )
}

export {
    OpportunityList
}